"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DescriptionList = void 0;
var _Stack = _interopRequireDefault(require("../Stack"));
var _DescriptionContext = _interopRequireDefault(require("./DescriptionContext"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DescriptionList = exports.DescriptionList = function DescriptionList(_ref) {
  var children = _ref.children,
    data = _ref.data,
    _ref$stripEmpty = _ref.stripEmpty,
    stripEmpty = _ref$stripEmpty === void 0 ? true : _ref$stripEmpty,
    _ref$disableGutters = _ref.disableGutters,
    disableGutters = _ref$disableGutters === void 0 ? false : _ref$disableGutters,
    _ref$dense = _ref.dense,
    dense = _ref$dense === void 0 ? false : _ref$dense,
    _ref$termWidth = _ref.termWidth,
    termWidth = _ref$termWidth === void 0 ? '25%' : _ref$termWidth,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'row' : _ref$variant,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 2 : _ref$spacing;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DescriptionContext["default"].Provider, {
    value: {
      data: data,
      stripEmpty: stripEmpty,
      disableGutters: disableGutters,
      dense: dense,
      termWidth: termWidth,
      variant: variant
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
      "data-cy": 'DescriptionList',
      spacing: spacing,
      children: children
    })
  });
};
DescriptionList.propTypes = {
  data: _propTypes["default"].object,
  stripEmpty: _propTypes["default"].bool,
  disableGutters: _propTypes["default"].bool,
  dense: _propTypes["default"].bool,
  termWidth: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['row', 'column']),
  spacing: _propTypes["default"].number
};